<template>
  
      <div id="app_container">

        <!-- intro sequence -->
        <section v-if="items.related_intro_steps" id="intro">
          <Intro :items="items.related_intro_steps" />
        </section>

        <!-- intro text -->
        <section v-if="items.intro_section" id="definition">
          <IntroText :items="items.intro_section"></IntroText>
        </section>

        <!-- case studies -->
        <section id="case_studies">
          <CaseStudies :items="items.related_case_studies" :case_study_section="items.case_study_section" />
        </section>

        <!-- personal upstander -->
        <section id="upstanders_you_know">
          <PersonalUpstander :items="items.personal_upstander_section" />
        </section>

        <!-- transition section -->
        <section id="what_are_human_rights">
        <div class="min-vh-100 d-flex align-items-center justify-content-center transition-bg" style="">
          <div class="d-flex align-items-center justify-content-center" v-for="i in items.transition_section" :key="i.id" style="min-height: 85vh; width: 90vw; background-color: white;">
            <h2 class="title2 text-center p-5">{{ $t(iKey('transition_section', i, 'text')) }}</h2>
          </div>
        </div>
        </section>

        <!-- profiles intro + profiles -->
        <section id="upstanders">
          <Profiles :items="items.related_upstander_profiles" :profiles_section="items.profiles_section" />
        </section>
        
        <!-- udhr intro + articles -->
        <section>
          <Udhr :items="items"/>
        </section>

        <!-- know -->
        <section>
          <Know :items="items"></Know>
        </section>

        <!-- tell -->
        <section id="tell">
          <Tell :items="items.related_udhr_articles"
                :userName="userName"
                :userStrength="userStrength"
                :userCause="userCause"></Tell>
        </section>

        <!-- -->
        <section id="act" >
          <Act :act_section="items.act_section"></Act>
        </section> 

        
        <!-- canada's upstanders -->
        <section id="canadas_upstanders">
          <CanadasUpstanders :canadas_upstanders_section="items.canadas_upstanders_section" :items="items.related_upstander_schools"></CanadasUpstanders>
        </section>

        <section id="share" class="mt-5">
          <SocialShare></SocialShare>
        </section>

      </div>
    
  
</template>

<script>
import { mapState } from 'vuex'
import { vueWindowSizeMixin } from 'vue-window-size';

import Intro  from '@/components/intro/Intro.vue'
import IntroText  from '@/components/intro/IntroText.vue'
import CaseStudies  from '@/components/case_studies/CaseStudies.vue'
import PersonalUpstander from '@/components/personal_upstander/PersonalUpstander.vue'
import Profiles  from '@/components/profiles/Profiles.vue'
import Udhr from '@/components/udhr/Udhr.vue'
import Know from '@/components/know/Know.vue'
import Tell from '@/components/tell/Tell.vue'
import Act from '@/components/act/Act.vue'
import CanadasUpstanders from '@/components/canadas_upstanders/CanadasUpstanders.vue'
import SocialShare from '@/components/ui/SocialShare.vue'

export default {
  name: 'Page',
  components: {
    Intro,
    IntroText,
    CaseStudies,
    PersonalUpstander,
    Profiles,
    Udhr,
    Know,
    Tell,
    Act,
    CanadasUpstanders,
    SocialShare
  },
  mixins: [vueWindowSizeMixin],
  computed: {
    ...mapState('page', ['items', 'userName', 'userStrength', 'userCause']),
  },
  mounted() {
    //this.$store.dispatch('page/GET_ITEMS')
    //console.log(this.$store.state.page)
    //this.$i18n.locale = 'en'

    // const scene = this.$scrollmagic.scene({
    //     triggerElement: '#transition_section',
    //     triggerHook: 0,
    //     duration: this.windowHeight,
    //     reverse: true
    // })
    // this.$scrollmagic.addScene(
    //   scene
    //     .setPin('#transition_section')
    //     //.addIndicators({name: 'Scene 2'})
    // )

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#app_container {
  overflow-x: hidden;
}
  .transition-bg {
    background-image:url(../assets/images/composition-pattern.jpg); 
    background-size: cover;
  }

</style>
